import "./IconAcademy.scss";
import { ReactComponent as AcademyIcon } from "./svg/icon_academy.svg";

type Props = {
  color?: "white" | "indigo";
};

export const IconAcademy = ({ color = "white" }: Props) => {
  return (
    <span className={`IconAcademy IconAcademy--${color}`}>
      <AcademyIcon />
    </span>
  );
};
